// hooks/useSuspensionPoll.js
// Session 38 — Polling léger de l'endpoint /api/auth/suspension-notice
//
// Appelé dans App.js au niveau top. Poll toutes les POLL_INTERVAL_MS quand
// un token est présent. Dès qu'une notice arrive, le state est exposé pour
// alimenter le SuspensionNoticeOverlay.

import { useEffect, useState, useRef } from 'react';

const POLL_INTERVAL_MS = 5000;

export default function useSuspensionPoll() {
  const [notice, setNotice] = useState(null);
  const activeRef = useRef(true);

  useEffect(() => {
    activeRef.current = true;
    let timerId = null;

    const tick = async () => {
      if (!activeRef.current) return;
      const token = localStorage.getItem('oracle_token');
      if (!token) {
        setNotice(null);
      } else {
        try {
          const apiBase = process.env.REACT_APP_API_URL || '';
          // Cache buster pour éviter toute mise en cache navigateur
          const res = await fetch(`${apiBase}/api/auth/suspension-notice?_=${Date.now()}`, {
            headers: { 'Authorization': `Bearer ${token}`, 'Cache-Control': 'no-cache' },
            cache: 'no-store',
          });
          if (res.ok) {
            const data = await res.json();
            if (data && data.notice) {
              setNotice(data.notice);
            } else {
              setNotice(null);
            }
          }
        } catch {
          // silencieux — on réessaie au prochain tick
        }
      }
      if (activeRef.current) {
        timerId = setTimeout(tick, POLL_INTERVAL_MS);
      }
    };

    tick();

    return () => {
      activeRef.current = false;
      if (timerId) clearTimeout(timerId);
    };
  }, []);

  return notice;
}
